import { gql } from "@apollo/client";

export const RERUN_ALL = gql`
  mutation reRunAll($accountId: Int!) {
    reRunAll(accountId: $accountId) {
      message
      isError
    }
  }
`;
